import FDictionary from '../__select';
import Form from './Form';

export default class FDictionaryRoomCategory extends FDictionary {
  dictionary = 'roomCategory';

  permissionAdd = [115];

  addForm() {
    const item = new Form();
    item.init()
      .then();
    return item;
  }
}
